import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IConstantsStrings extends LocalizedStringsMethods {
    lsFootballTxt: string;
    lsSoccerTxt: string;
    lsHockeyTxt: string;
    lsBaseballTxt: string;
    lsBasketballTxt: string;
    lsSoftballTxt: string;
    lsTennisTxt: string;
    lsVolleyballTxt: string;
    lsMixedMartialArtsTxt: string;
    lsBoxingTxt: string;
    lsSkiingTxt: string;
    lsSnowboardingTxt: string;
    lsLacrosseTxt: string;
    lsTrackandFieldTxt: string;
    lsPoloTxt: string;
    lsRugbyTxt: string;
    lsCyclingTxt: string;
    lsWalkingTxt: string;
    lsDivingTxt: string;
    lsWeightliftingTxt: string;
    lsHighSchoolTxt: string;
    lsProfessionalTxt: string;
    lsUniversityTxt: string;
    lsJuniorHighTxt: string;
    lsYouthTxt: string;
    lsOtherTxt: string;
    lsAmateurTxt: string;
    lsElementarySchoolTxt: string;
    lsMiddleSchoolTxt: string;
    lsLowerSchoolTxt: string;
    lsUpperSchoolTxt: string;
    lsSeverlyImpairedTxt: string;
    lsModeratelyImpairedTxt: string;
    lsMildlyImpairedTxt: string;
    lsBorderlineTxt: string;
    lsLowAverageTxt: string;
    lsAverageTxt: string;
    lsHighAverageTxt: string;
    lsSuperiorTxt: string;
    lsVerySuperiorTxt: string;
    lsViewStateHomeTxt: string;
    lsViewStateRosterTxt: string;
    lsViewStateUserTxt: string;
    lsViewStateTestTxt: string;
    lsViewStateNotificationTxt: string;
    lsViewStateOrgTxt: string;
    lsViewStateLogoutTxt: string;
    lsViewStateExternalHomeTxt: string;
    lsViewStateDashboardTxt: string;
    lsViewStateEmployeeTxt: string;
    lsViewStateAuditTxt: string;
    lsTestFileName: string;
    lsBaselineTxt: string;
    lsTestTxt: string;
    lsYesTxt: string;
    lsNoTxt: string;
    lsBothTxt: string;
    lsFemaleTxt: string;
    lsMaleTxt: string;
    lsUnspecifiedTxt: string;
    lsNoValueTxt: string;
    lsHasValueTxt: string;
    lsEitherTxt: string;
    lsViewStateCustomerTxt: string;
}

let strings: IConstantsStrings;
export default strings = new LocalizedStrings({
    en: {        
        lsFootballTxt: 'Football',
        lsSoccerTxt: 'Soccer',
        lsHockeyTxt: 'Hockey',
        lsBaseballTxt: 'Baseball',
        lsBasketballTxt: 'Basketball',
        lsSoftballTxt: 'Softball',
        lsTennisTxt: 'Tennis',
        lsVolleyballTxt: 'Volleyball',
        lsMixedMartialArtsTxt: 'Mixed Martial Arts',
        lsBoxingTxt: 'Boxing',
        lsSkiingTxt: 'Skiing',
        lsSnowboardingTxt: 'Snowboarding',
        lsLacrosseTxt: 'Lacrosse',
        lsTrackandFieldTxt: 'Track and Field',
        lsPoloTxt: 'Polo',
        lsRugbyTxt: 'Rugby',
        lsCyclingTxt: 'Cycling',
        lsWalkingTxt: 'Walking',
        lsDivingTxt: 'Diving',
        lsWeightliftingTxt: 'Weightlifting',
        lsHighSchoolTxt: 'High School',   
        lsProfessionalTxt: 'Professional' ,
        lsUniversityTxt: 'University'  ,
        lsJuniorHighTxt: 'Junior High'  ,
        lsYouthTxt: 'Youth'   ,
        lsOtherTxt: 'Other',
        lsAmateurTxt: 'Recreational/Amateur',
        lsElementarySchoolTxt: 'Elementary School',
        lsMiddleSchoolTxt: 'Middle School / Junior High',
        lsLowerSchoolTxt: 'Lower School',
        lsUpperSchoolTxt: 'Upper School',
        lsSeverlyImpairedTxt: 'Extremely Poor',
        lsModeratelyImpairedTxt: 'Very Poor',
        lsMildlyImpairedTxt: 'Poor',
        lsBorderlineTxt: 'Borderline',
        lsLowAverageTxt: 'Low Average',
        lsAverageTxt: 'Average',
        lsHighAverageTxt: 'High Average',
        lsSuperiorTxt: 'Superior',
        lsVerySuperiorTxt: 'Very Superior',
        lsViewStateHomeTxt: 'home',
        lsViewStateRosterTxt: 'profile',
        lsViewStateUserTxt: 'user',
        lsViewStateTestTxt: 'test',
        lsViewStateNotificationTxt: 'notification',
        lsViewStateOrgTxt: 'organization',
        lsViewStateLogoutTxt: 'logout',
        lsViewStateExternalHomeTxt: 'externalhome',
        lsViewStateDashboardTxt: 'dashboard',
        lsViewStateEmployeeTxt: 'employee',
        lsViewStateAuditTxt : 'audit',        
        lsTestFileName: 'tests',
        lsBaselineTxt: 'Baseline',
        lsTestTxt: 'Test',
        lsYesTxt: 'Yes',
        lsNoTxt: 'No',
        lsBothTxt: 'Both', 
        lsFemaleTxt: 'Female',
        lsMaleTxt: 'Male',        
        lsUnspecifiedTxt: 'Unspecified',
        lsNoValueTxt: 'does not have a value',
        lsHasValueTxt: 'has a value',
        lsEitherTxt: 'either',
        lsViewStateCustomerTxt: 'customer', 
    },
    es: {        
        lsFootballTxt: 'Football',
        lsSoccerTxt: 'Soccer',
        lsHockeyTxt: 'Hockey',
        lsBaseballTxt: 'Baseball',
        lsBasketballTxt: 'Basketball',
        lsSoftballTxt: 'Softball',
        lsTennisTxt: 'Tennis',
        lsVolleyballTxt: 'Volleyball',
        lsMixedMartialArtsTxt: 'Mixed Martial Arts',
        lsBoxingTxt: 'Boxing',
        lsSkiingTxt: 'Skiing',
        lsSnowboardingTxt: 'Snowboarding',
        lsLacrosseTxt: 'Lacrosse',
        lsTrackandFieldTxt: 'Track and Field',
        lsPoloTxt: 'Polo',
        lsRugbyTxt: 'Rugby',
        lsCyclingTxt: 'Cycling',
        lsWalkingTxt: 'Walking',
        lsDivingTxt: 'Diving',
        lsWeightliftingTxt: 'Weightlifting',
        lsHighSchoolTxt: 'High School',   
        lsProfessionalTxt: 'Professional' ,
        lsUniversityTxt: 'University'  ,
        lsJuniorHighTxt: 'Junior High'  ,
        lsYouthTxt: 'Youth'   ,
        lsOtherTxt: 'Other',
        lsAmateurTxt: 'Recreational/Amateur',
        lsElementarySchoolTxt: 'Elementary School',
        lsMiddleSchoolTxt: 'Middle School / Junior High',
        lsLowerSchoolTxt: 'Lower School',
        lsUpperSchoolTxt: 'Upper School',
        lsSeverlyImpairedTxt: 'Gravemente impedido',
        lsModeratelyImpairedTxt: 'Moderadamente deteriorado',
        lsMildlyImpairedTxt: 'Levemente deteriorado',
        lsBorderlineTxt: 'Límite',
        lsLowAverageTxt: 'Promedio bajo',
        lsAverageTxt: 'Promedio',
        lsHighAverageTxt: 'Alto promedio',
        lsSuperiorTxt: 'Superior',
        lsVerySuperiorTxt: 'Very Superior',
        lsViewStateHomeTxt: 'home',
        lsViewStateRosterTxt: 'profile',
        lsViewStateUserTxt: 'user',
        lsViewStateTestTxt: 'test',
        lsViewStateNotificationTxt: 'notification',
        lsViewStateOrgTxt: 'organization',
        lsViewStateLogoutTxt: 'logout',
        lsViewStateExternalHomeTxt: 'externalhome',
        lsViewStateDashboardTxt: 'dashboard',
        lsViewStateEmployeeTxt: 'employee',
        lsViewStateAuditTxt : 'audit',        
        lsTestFileName: 'tests',
        lsBaselineTxt: 'Baseline',
        lsTestTxt: 'Test',
        lsYesTxt: 'Yes',
        lsNoTxt: 'No',
        lsBothTxt: 'Both', 
        lsFemaleTxt: 'Female',
        lsMaleTxt: 'Male',        
        lsUnspecifiedTxt: 'Unspecified',
        lsNoValueTxt: 'does not have a value',
        lsHasValueTxt: 'has a value',
        lsEitherTxt: 'either',
        lsViewStateCustomerTxt : 'customer', 
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/strings.constants.tsx